import { useEffect, useState } from "react";
import Router from "./router/router";
import { ToastContainer } from "react-toastify";
import NotificationHandler from "./Hooks/NotificationHandler";
import Cookies from "js-cookie";

function App() {
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    const id = Cookies.get("userID");
    if (id) {
      setUserId(id);
    }

    
    const interval = setInterval(() => {
      const updatedId = Cookies.get("userID");
      if (updatedId) {
        setUserId(updatedId);
        clearInterval(interval);
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <NotificationHandler userId={userId} />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        theme="light"
        pauseOnHover
        draggable
        newestOnTop
        limit={5}
        style={{ zIndex: 99999 }}
      />
      <Router />
    </>
  );
}

export default App;
